import React, { useContext } from 'react';
import {
    BooleanIcon,
    CategoryIcon,
    ChoiceIcon,
    DecimalIcon,
    FractionIcon,
    IntegerIcon,
    MultiChoiceIcon,
    SubModelIcon,
    TextIcon,
} from "assests/GmsIcons";

import { propertyObj } from './constants';
import { SB3RuleContext } from '../Rules/SB3RuleContext';
import { mapSelectOptions } from '../../helper';
import { getName, getType } from './helper';

// interface CardElement {
//     id: number;
//     category: string;
//     quantity: string;
//     integer: number;
// }

type LogicRuleMathTextAreaComponentProps = {
    nodes: any[],
    rootIndex: number,
    index: number,
    type: string

};

const LogicRuleMathTextAreaComponent = ({ nodes, rootIndex, index, type }: LogicRuleMathTextAreaComponentProps) => {
    const { updateNodeInMathCondtion, deleteNodeInMathCondtion } = useContext(SB3RuleContext);

    type PropertyObjKeys = keyof typeof propertyObj;
    return (
        <div className="tw-w-[630px] tw-h-14 tw-border tw-rounded tw-overflow-scroll  ">
            {
                nodes?.length > 0 ?
                nodes?.map((node: any, nodeIndex: number) => (

                    <div key={nodeIndex} className={`tw-m-1 tw-h-8 tw-align-middle ${node?.type === "operator" ? 'tw-bg-sky-100' : 'tw-bg-gray-100'}   tw-rounded tw-border tw-border-zinc-200 tw-inline-flex tw-items-center tw-justify-center tw-text-center tw-gap-2`}>
                        {
                            node?.type === "numerical" ?
                                <input
                                onChange={(e) => {
                                    updateNodeInMathCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'name')
                                }}
                                    className='tw-w-20 tw-ml-2 tw-rounded tw-border' />
                                :
                                <>
                                    <span className={`${(getType(node?.type, node?.field_type) === "choice" || getType(node?.type, node?.field_type) === "product") ? 'tw-m-2' : 'tw-m-1'}`}>
                                        {getType(node?.type, node?.field_type) === "submodel" ? <SubModelIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "multi-choice" ? <MultiChoiceIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "text" ? <TextIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "decimal" ? <DecimalIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "fraction" ? <FractionIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "integer" ? <IntegerIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "boolean" ? <BooleanIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "choice" ? <ChoiceIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "product" ? <ChoiceIcon /> : null}
                                        {getType(node?.type, node?.field_type) === "category" ? <CategoryIcon /> : null}
                                    </span> 
                                    <span className="">
                                        {getName(node?.type, node)}
                                    </span>
                                </>
                        }
                        {(node?.type !== "operator" && node?.type !== "numerical") ?
                            <select value={node?.property}
                                onChange={(e) => {
                                    updateNodeInMathCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'property')
                                }}
                                className="tw-h-4  tw-text-xs tw-bg-gray-100 tw-text-indigo-700" >
                                {mapSelectOptions(propertyObj[getType(node?.type, node?.field_type) as PropertyObjKeys])}
                            </select> : null
                        }
                        <button className='tw-text-xs  tw-mb-2 tw-text-red-500  tw-rounded-full tw-w-5 tw-h-5' onClick={() =>
                            deleteNodeInMathCondtion(rootIndex, index, type, nodeIndex

                            )} >x</button>
                </div>
                )) : <p className='tw-text-gray-200'>Enter math expression</p>
            }


        </div >
    );
};

export default LogicRuleMathTextAreaComponent;
